// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InformesPage_menuContainer__cIWO3 {
  width: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.InformesPage_menuIntro__FPBi1 {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #475569;
}

.InformesPage_menuTitle__VVpM2 {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 700;
  color: #0f172a;
}

.InformesPage_menuSubtitle__ytDfs {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.45;
}

.InformesPage_menuGrid__RMQKR {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
}

@media (max-width: 600px) {
  .InformesPage_menuContainer__cIWO3 {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/principal/panel/informes/InformesPage.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".menuContainer {\n  width: 100%;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.menuIntro {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  color: #475569;\n}\n\n.menuTitle {\n  margin: 0;\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.menuSubtitle {\n  margin: 0;\n  font-size: 0.95rem;\n  line-height: 1.45;\n}\n\n.menuGrid {\n  display: grid;\n  gap: 20px;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n}\n\n@media (max-width: 600px) {\n  .menuContainer {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuContainer": `InformesPage_menuContainer__cIWO3`,
	"menuIntro": `InformesPage_menuIntro__FPBi1`,
	"menuTitle": `InformesPage_menuTitle__VVpM2`,
	"menuSubtitle": `InformesPage_menuSubtitle__ytDfs`,
	"menuGrid": `InformesPage_menuGrid__RMQKR`
};
export default ___CSS_LOADER_EXPORT___;
